import React from 'react'

export default function TelephoneSvg({fill = '#000', className = ''}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500.2" fill={fill} className={className}>
      <path d="M128 199l16-13 45-37c5-5 8-12 6-20l-2-7-46-107c-2-4-4-8-8-11-5-4-10-5-16-3L19 25 8 29c-5 4-8 9-8 16a274 274 0 003 52 423 423 0 00102 241 512 512 0 00130 107 422 422 0 00230 53c5-3 8-8 10-13l9-39 15-66c1-3 2-7 1-11-1-5-4-9-9-12l-14-7-100-43c-3-1-7-3-11-3-6 1-11 3-15 7l-13 16-36 44-2 1a352 352 0 01-172-173z" />
    </svg>
  )
}
